export const APP_SAVE_CONFIG = 'saveAppConfig'
export const APP_SET_LOCALE = 'setAppLocale'
export const APP_SET_OPTION = 'setAppOption'
export const APP_SET_ROUTE_OPTION = 'setAppRouteOption'
export const APP_SET_TARGET_URL = 'setAppTargetUrl'
export const APP_SET_TITLE = 'setAppTitle'
export const APP_WIPE_TARGET_URL = 'wipeAppTargetUrl'
